import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MaterialModule } from '../../_shared';


@Component({
  selector: 'app-contact',
  imports: [MaterialModule],
  templateUrl: './contact.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contact.scss',
})
export class Contact implements OnInit {

  constructor() {}


  ngOnInit(): void {

  }


  sendEmail() {

    // const email = 'wholesomestorytime@gmail.com';
    // const subject = 'Wholesome storytime online inquiry';
    // const body = '';
    // const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
    // window.location.href = mailtoLink;
  }


}
